// Xanterra links need destination, dateFrom, nights, adults, and children.
// The dataset's #roomCode fragment opens the selected booking modal for both
// lodge and campground units. URLSearchParams preserves that fragment.

import { addDays, format } from "date-fns";
import { resolveMinStayLength, resolveMinCapacity } from "./_context.js";

// Default preview-URL window: 30 days out, 1 night, 2 adults. The user
// is just browsing the room list; specific dates aren't load-bearing
// for that purpose, but the booking page won't render without them.
const PREVIEW_DAYS_AHEAD = 30;
const PREVIEW_NIGHTS = 1;
const PREVIEW_ADULTS = 2;

function buildXanterraUrl(site, { arrivalDate, nights, adults }) {
  const url = new URL(site.reserveUrl);
  url.searchParams.set("adults", String(adults));
  url.searchParams.set("children", "0");
  url.searchParams.set("rateCode", "");
  url.searchParams.set("rateType", "");
  url.searchParams.set("dateFrom", format(arrivalDate, "MM-dd-yyyy"));
  url.searchParams.set("nights", String(nights));
  return url.toString();
}

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    return buildXanterraUrl(site, {
      arrivalDate,
      nights: resolveMinStayLength(ctx),
      adults: resolveMinCapacity(ctx),
    });
  },

  // Preview URL: same shape as the booking URL, with sensible defaults
  // since the request form runs before the user has picked dates. The
  // user just wants to see what rooms are bookable at this property.
  buildPreviewUrl(site) {
    return buildXanterraUrl(site, {
      arrivalDate: addDays(new Date(), PREVIEW_DAYS_AHEAD),
      nights: PREVIEW_NIGHTS,
      adults: PREVIEW_ADULTS,
    });
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as dateFrom=MM-DD-YYYY (dashes, not slashes).",
        },
        departureDate: {
          status: "required",
          notes: "Used to derive nights=<count>.",
        },
        ref: {
          status: "ignored",
          notes:
            "site.reserveUrl identifies the property and the selected room/site via its fragment.",
        },
        partySize: {
          status: "optional",
          defaultValue: 1,
          notes: "Encoded as adults=<count>; children is hardcoded to 0.",
        },
      },
    };
  },
};
